import { render, staticRenderFns } from "./TaxReturnOtherCompanyCostsSection.vue?vue&type=template&id=4161621e&scoped=true&"
import script from "./TaxReturnOtherCompanyCostsSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnOtherCompanyCostsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4161621e",
  null
  
)

export default component.exports